import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Lottie from "lottie-react";
import pageNotFoubdAnimation from '../lotties/pageNotFound.json'
import "./PageNotFound.css";

const PageNotFound = () => {
  return (
    <Container className="fluid">
      <Row className="justify-content-md-center">
      <Col className="md-12">
        <Lottie 
          animationData={pageNotFoubdAnimation} 
          loop={true} 
          height={50}
          width={50}/>
        </Col>
      </Row>
    </Container>
  );
};

export default PageNotFound;
